<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeFilter")
            div.m-l-sm.float-right.mode-filter
                select.form-control.c-select(
                    @change="setModeFilter"
                )
                    option(:value="null") Filter modifier mode
                    option(:value="0") Instruction
                    option(:value="1") Topup
                    option(:value="2") Deduct
                    option(:value="3") Discount
    receipt(ref="receipt")
</template>

<style lang="scss">
@media screen and (max-width: 767px) {
    .mode-filter {
        margin-left: 0 !important;
        margin-right: 0;
        margin-bottom: 0.5rem;
        float: none !important;
    }
}
</style>

<script>
import receiptMixin from '../../mixins/receipt';
export default {
    mixins: [receiptMixin],

    data: function() {
        var that = this;
        return {
            tableName: 'VUETABLE_MODIFIER',
            columns: [
                'settled_date',
                'sequence_number',
                'product_name',
                'name',
                'total_qty_modifier',
                'mode_name',
                'net_sales',
                'total_sales',
                // 'modifier_topup',
                // 'modifier_deduct',
                // 'modifier_discount',
            ],
            options: {
                texts: {
                    title: 'Modifier Sales',
                    description: 'Modifier Sales Report',
                },
                useReportFilter: true,
                initFilters: {
                    mode: null,
                },
                headings: {
                    settled_date: 'Settled Date',
                    sequence_number: 'Receipt No.',
                    name: 'Modifier Name',
                    product_name: 'Product Name',
                    mode_name: 'Modifier Mode',
                    total_qty_modifier: 'Total Quantity',
                    net_sales: 'Net Sales',
                    total_sales: 'Total Sales',
                    // modifier_topup: 'Modifier Topup',
                    // modifier_deduct: 'Modifier Deduct',
                    // modifier_discount: 'Modifier Discount',
                },

                templates: {
                    mode(h, row) {
                        return row.mode_name;
                    },
                    net_sales(h, row) {
                        let modifier = 0;
                        if (row.mode == 1) {
                            modifier = parseFloat(
                                (row.modifier_topup || '0')
                                    .toString()
                                    .replace(/,/g, ''),
                            );
                        } else if (row.mode == 2) {
                            modifier = parseFloat(
                                (row.modifier_deduct || '0')
                                    .toString()
                                    .replace(/,/g, ''),
                            );
                        } else if (row.mode == 3) {
                            modifier = parseFloat(
                                (row.modifier_discount || '0')
                                    .toString()
                                    .replace(/,/g, ''),
                            );
                        } else {
                            modifier = 0;
                        }
                        return numeral(modifier).format('0,0.00');
                    },
                    total_sales(h, row) {
                        let result = 0;
                        if (row.mode == 1) {
                            result = parseFloat(
                                (row.modifier_topup || '0')
                                    .toString()
                                    .replace(/,/g, ''),
                            );
                        } else if (row.mode == 2) {
                            result = parseFloat(
                                (row.modifier_deduct || '0')
                                    .toString()
                                    .replace(/,/g, ''),
                            );
                        } else if (row.mode == 3) {
                            result = parseFloat(
                                (row.modifier_discount || '0')
                                    .toString()
                                    .replace(/,/g, ''),
                            );
                        } else {
                            result = 0;
                        }
                        return numeral(result).format('0,0.00');
                    },
                    modifier_deduct(h, row) {
                        const result =
                            row.modifier_deduct -
                            (row.modifier_deduct * row.modifier_set_discount) /
                                100;
                        return numeral(parseFloat(result)).format();
                    },
                    settled_date(h, row) {
                        return moment(row.settled_date).format(
                            'DD/MM/YYYY hh:mm A',
                        );
                    },

                    sequence_number(h, row) {
                        let ids = [
                            row.sequence_number,
                            row.receipt_number.substr(0, 6),
                        ];
                        return ids.filter(s => s != null).join('/');
                    },
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: row => {
                    this.showReceipt(row.transaction_id);
                },

                customFilters: ['mode'],
                pdf_url: Laroute.route(
                    'franchise.report.modifier.exportAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.modifier.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.modifier.exportAsFile',
                    { type: 'XLSX' },
                ),
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.report.modifier.index');
        },
    },

    methods: {
        setModeFilter(e) {
            const val = e.target.value || null;
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'mode',
                value: val,
            });
        },
        showReceipt(transaction_id) {
            this.$refs.receipt.$emit('show-receipt', transaction_id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/modifier/index.vue